/* tslint:disable */
/* eslint-disable */
/**
 * OSB Workspaces manager API
 * Opensource Brain Platform - Reference Workspaces manager API
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    DandiRepositoryResource,
    FigshareRepositoryResource,
    GITRepositoryResource,
    DandiRepositoryResourceFromJSONTyped,
    DandiRepositoryResourceToJSON,
    FigshareRepositoryResourceFromJSONTyped,
    FigshareRepositoryResourceToJSON,
    GITRepositoryResourceFromJSONTyped,
    GITRepositoryResourceToJSON,
} from './';

/**
 * @type RepositoryResource
 * Repository resource
 * @export
 */
export type RepositoryResource = DandiRepositoryResource | FigshareRepositoryResource | GITRepositoryResource;

export function RepositoryResourceFromJSON(json: any): RepositoryResource {
    return RepositoryResourceFromJSONTyped(json, false);
}

export function RepositoryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepositoryResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...DandiRepositoryResourceFromJSONTyped(json, true), ...FigshareRepositoryResourceFromJSONTyped(json, true), ...GITRepositoryResourceFromJSONTyped(json, true) };
}

export function RepositoryResourceToJSON(value?: RepositoryResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return { ...DandiRepositoryResourceToJSON(value), ...FigshareRepositoryResourceToJSON(value), ...GITRepositoryResourceToJSON(value) };
}

